export default __webpack_public_path__ + "static/media/DSC_7469.5c5c84c9.jpg";